module.exports = __webpack_public_path__ + "assets/media/googlemeet-icon.37f11f02.svg";